import {Injectable} from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot, UrlTree, Router
} from '@angular/router';
import {Observable} from "rxjs";
import {SubscriptionService} from "../services/subscription.service";
import {environment} from "../../environments/environment";

@Injectable({providedIn: 'root'})
export class OnboardGuard implements CanActivate {
  constructor(private subscriptionService: SubscriptionService, private subService: SubscriptionService, public router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return new Promise(async (resolve) => {

      this.debugLog('Onboard Guard Started');
        // SUBSCRIPTION HAS ALREADY BEEN CHECKED AND STORED IN SUBJECT, DON'T REPEAT IT TO REDUCE MEMORY / CPU LOAD
        if(this.subService.onboardingFlags.value?.BrandActive && this.subService.onboardingFlags.value?.BrandActive > 0){
          resolve(true);
        }else{

          if(this.subService.onboardingFlags.value?.BrandCreated){
            this.router.navigateByUrl('/admin/brands');
          }else{
            this.router.navigateByUrl('/admin/brands/create');
          }

          resolve(false);
        }

    });
  }

  debugLog(message:string){
    if(!environment.production){
      console.log(message);
    }
  }

}
